import { setLocale } from 'yup'

import locale from './locales/ru'
import './methods'

setLocale(locale)
